<header class="{{pricing.open?'hide':'align-left'}} {{!isFrame?'mw-70':'mw-100'}}">
  <h4 *ngIf="pricing" class="{{!isFrame?'width-165p':'width-100'}} inline-block">{{ pricing.label }} </h4>
  <h4 *ngIf="pricing.openDate && pricing.IsComing" style=" display: block;font-size: 12px !important;color: green" >{{ pricing.openDate |datefrench }} </h4>
  <!--  //si description-->
  <h6 *ngIf="pricing && pricing.description" style="display: inline-block"><a class="detailClass" data-toggle="collapse" href="#collapse{{pricing.id}}">({{'front_event.detail'| translate}})</a></h6>
  <!-- //si pas de description-->
  <p class="ticket-desc">{{nbPlace(pricing)}}</p>
</header>

<!--<div class="collapse margin-desc"  style="max-width: 100%" id="collapse{{pricing.id}}">

</div>-->
